import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, LayoutGrid } from "lucide-react";
import { fmtFila, Variacion } from "./kpi";

export function Destacados({ items, to, titulo, testid }) {
  if (!items?.length) return null;
  return (
    <section className="mb-8" data-testid={testid}>
      <div className="flex items-end justify-between gap-3 mb-3 flex-wrap">
        <h2 className="text-xs uppercase tracking-widest font-bold text-slate-400">{titulo}</h2>
        <Link to={to} className="text-xs font-semibold text-sky-700 hover:text-sky-900 inline-flex items-center gap-1" data-testid={`${testid}-ver-todos`}>
          <LayoutGrid size={13} /> Ver todos los indicadores <ArrowRight size={12} />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {items.map((f) => (
          <Link key={f.key} to={`${to}#ind-${f.key}`} data-testid={`destacado-${f.key}`}
                className="card p-4 group hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow]">
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold leading-tight min-h-[24px]">{f.label}</div>
            <div className={"font-display text-xl sm:text-2xl font-extrabold mt-1 " + (f.malo && f.actual ? "text-red-600" : "")}>{fmtFila(f, f.actual)}</div>
            <div className="mt-1 text-[11px] min-h-[16px]">
              {f.var_anterior !== undefined ? <Variacion v={f.var_anterior} unit={f.unit} inverso={f.inverso} />
                : <span className="text-slate-400 line-clamp-1">{f.desc}</span>}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-sky-700 font-semibold mt-2 opacity-0 group-hover:opacity-100 transition-opacity">Ver detalle →</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
